// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionSwitcher_container__2uBTn"};